import { createActionGroup, props } from '@ngrx/store';
import { dialogFeatureKey } from './selectors';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogCheckboxData, DialogCheckboxResult, DialogData } from '../dialogs.model';

export const DialogsActions = createActionGroup({
  source: dialogFeatureKey,
  events: {
    showDialog: props<{ data: DialogData; callback?: (...args: any[]) => void }>(),
    showDialogCheckbox: props<{
      data: DialogCheckboxData;
      callback?: (result: DialogCheckboxResult) => void;
    }>(),
    setRef: props<{ ref: MatDialogRef<any> | null }>(),
  },
});
